import { render, staticRenderFns } from "./TaskColumn.vue?vue&type=template&id=11b06688&v-slot=props&"
import script from "./TaskColumn.vue?vue&type=script&lang=js&"
export * from "./TaskColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports